import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import CollaboratorTypeServices from "./CollaboratorType.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCollaboratorType = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COLLABORATOR_TYPE,
      payload: true,
    });
    const resp = await CollaboratorTypeServices.getCollaboratorType(filters);
    dispatch({
      type: actions.GET_COLLABORATOR_TYPE,
      payload: {
        collaboratorTypes: resp.data.data,
        collaboratorTypesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.COLLABORATOR_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COLLABORATOR_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COLLABORATOR_TYPE,
      payload: false,
    });
  }
};

export const getCollaboratorTypeById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COLLABORATOR_TYPE,
      payload: true,
    });
    const resp = await CollaboratorTypeServices.getCollaboratorTypeByID(id);
    dispatch({
      type: actions.GET_COLLABORATOR_TYPE,
      payload: {
        collaboratorTypes: resp.data,
      },
    });
    dispatch({
      type: actions.COLLABORATOR_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COLLABORATOR_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COLLABORATOR_TYPE,
      payload: false,
    });
  }
};

export const saveCollaboratorType =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_COLLABORATOR_TYPE,
        payload: true,
      });
      const resp = await CollaboratorTypeServices.saveCollaboratorType(data);
      const { collaboratorTypes, collaboratorTypesLength } = getState().notificationsCollaboratorType;
      const _collaboratorTypes = [...collaboratorTypes, resp.data];
      dispatch({
        type: actions.GET_COLLABORATOR_TYPE,
        payload: {
          collaboratorTypes: _collaboratorTypes,
          collaboratorTypesLength: collaboratorTypesLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_COLLABORATOR_TYPE,
        payload: false,
      });
    }
  };

export const editCollaboratorType =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_COLLABORATOR_TYPE,
        payload: true,
      });
      const resp = await CollaboratorTypeServices.editCollaboratorType(id, data);
      const { collaboratorTypes, collaboratorTypesLength } = getState().notificationsCollaboratorType;
      let _collaboratorTypes = [...collaboratorTypes]
      _collaboratorTypes[index] = resp.data;
      dispatch({
        type: actions.GET_COLLABORATOR_TYPE,
        payload: {
          collaboratorTypes: _collaboratorTypes,
          collaboratorTypesLength: collaboratorTypesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_COLLABORATOR_TYPE,
        payload: false,
      });
    }
  };

export const deleteCollaboratorType = (id, index) => async (dispatch, getState) => {
  try {
   
    dispatch({
      type: actions.LOADING_COLLABORATOR_TYPE,
      payload: true,
    });
    await CollaboratorTypeServices.deleteCollaboratorType(id);
    const { collaboratorTypes, collaboratorTypesLength } = getState().notificationsCollaboratorType;
    let _collaboratorTypes = [...collaboratorTypes]
    _collaboratorTypes.splice(index, 1);
    dispatch({
      type: actions.GET_COLLABORATOR_TYPE,
      payload: {
        collaboratorTypes: _collaboratorTypes,
        collaboratorTypesLength: collaboratorTypesLength - 1,
      },
    });
    dispatch({
      type: actions.COLLABORATOR_TYPE_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;                         
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.COLLABORATOR_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COLLABORATOR_TYPE,
      payload: false,
    });
  }
};
